import { styled } from '@mui/material/styles'
import { keyframes } from '@mui/system'

import { Typography, Button } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'

export const StyledLoadingButton = styled(LoadingButton)({
    backgroundColor: '#1f2768',
    marginBottom: 8,
    justifyContent: 'center',
    ':hover': {
        backgroundColor: 'rgba(24, 29, 85, 0.8)',
        color: 'white'
    },
    width: '100%',
    '&:disabled': {
        backgroundColor: '#181d55',
        overflow: 'hidden',
        color: 'rgba(255, 255, 255, 0.2)'
    },
    '&:error': {
        color: 'rgba(255, 0, 0, 0.5)'
    },
    '&& .MuiLoadingButton-startIconLoadingStart': {
        position: 'absolute'
    }
})

export const StyledButtonTypography = styled(Typography)({
    fontSize: 18,
    fontColor: 'rgba(240, 240, 240, 0.9)',
    justifyContent: 'center',
    marginTop: 5,
    marginBottom: 5,
    textTransform: 'none'
})

const blink = keyframes`
  from { opacity: 0.3 }
  to { opacity: 1 }
`

export const BlinkingButton = styled(Button)({
    '&:hover': {
        background: 'none'
    },
    '& .MuiTouchRipple-root span': {
        backgroundColor: '#4c68ee',
        opacity: 0.001
    },
    '& .MuiTouchRipple-rippleVisible': {
        animationDuration: '200ms'
    },
    animation: `${blink} 1s linear 10`
})
